import React from 'react';
const BRANDS = [{
  name: 'Sprouts',
  logo: 'https://cdn.magicpatterns.com/uploads/iYHbH3XdLiMT7V9sLf2q94/sprouts-logo-color-1024x512.webp'
}, {
  name: 'KinderCare',
  logo: 'https://cdn.magicpatterns.com/uploads/qw7pyUokw2MFZShd1pWct7/kindercare-logo-color.svg'
}, {
  name: "Nando's",
  logo: 'https://cdn.magicpatterns.com/uploads/qWaZNUo2aCmDRdqqqFLf9R/nandos-logo-color.svg'
}, {
  name: 'Maricopa Water & Ice',
  logo: 'https://cdn.magicpatterns.com/uploads/djHtDhqdS9C5TV1ZUarp3j/mwi-logo-color.webp'
}, {
  name: 'Bosa Donuts',
  logo: 'https://cdn.magicpatterns.com/uploads/gimLGC1tK4bEGhfG7X2jky/bosa-donuts-logo-color.svg'
}, {
  name: 'Original ChopShop',
  logo: 'https://cdn.magicpatterns.com/uploads/izVKWockzo8wUBBvgPp6ZU/chopshop-logo-1024x512.webp'
}, {
  name: 'Darwin Wall Real Estate',
  logo: 'https://cdn.magicpatterns.com/uploads/rzx3WuRs4bJNaWmswiLQUw/darwin-wall-real-estate-team-logo-1024x512.webp'
}, {
  name: "Duke's Roadhouse",
  logo: 'https://cdn.magicpatterns.com/uploads/7bi4VAck2R5Q4Z3bM5nKMT/dukes-roadhouse-logo-color-1024x512.webp'
}, {
  name: 'Extra Space Storage',
  logo: 'https://cdn.magicpatterns.com/uploads/w34C4kmxV9ZZ4pgNsjYEZ6/extra-space-storage-color.svg'
}, {
  name: 'Thai Chili 2 Go',
  logo: 'https://cdn.magicpatterns.com/uploads/fqGSHWQJvxMJKpiL6dnauJ/thai-chili-2-go-logo-color.svg'
}, {
  name: 'Birdcall',
  logo: 'https://cdn.magicpatterns.com/uploads/rAxsEjLrCNxL37ZA1dfhiJ/birdcall-logo-color.svg'
}];
export function LogoMarquee() {
  return <div className="w-full border-t" style={{
    backgroundColor: '#ffffff',
    borderColor: '#E8F4FD'
  }} data-id="element-511">
      <div className="max-w-7xl mx-auto px-4 py-5" data-id="element-512">
        <p className="text-center text-xs uppercase tracking-widest mb-4 font-semibold" style={{
        color: '#0283C7',
        fontFamily: 'Inter, sans-serif',
        letterSpacing: '0.15em',
        opacity: 0.7
      }} data-id="element-513">
          Trusted by Local Arizona Businesses
        </p>
      </div>
      <div className="overflow-hidden py-6" data-id="element-514">
        <div className="marquee-track" data-id="element-515">
          {[...BRANDS, ...BRANDS].map((brand, i) => <span key={i} className="inline-flex items-center justify-center px-10" style={{
          whiteSpace: 'nowrap'
        }} data-id="element-516">
              <img src={brand.logo} alt={brand.name} className="h-20 w-auto object-contain" style={{
            maxWidth: '200px',
            opacity: 0.9
          }} data-id="element-517" />
              <span className="ml-10 opacity-20" style={{
            color: '#0283C7'
          }} data-id="element-518">
                •
              </span>
            </span>)}
        </div>
      </div>
    </div>;
}